import { IS_DEVELOPMENT } from "@/core/constants";
import { Logger } from "@/core/utilities";

export function getImageUrl(fileName?: string) {
  return new URL(`../../assets/images/${fileName}`, import.meta.url).href;
}

export function getFlagIconUrl(name?: string) {
  return new URL(`../icons/flags/${name}.svg`, import.meta.url).href;
}

export function getIconUrl(name?: string) {
  return new URL(`../icons/${name}.svg`, import.meta.url).href;
}

// NOTE: responses are no longer sanitized due to a vulnerability issue in DOMPurify,
// so we need to be careful with the icons we add here. Only add icons that are necessary and from a trusted source.
// Check all repository SVGs for potentioal vulnerabilities, such as script tags, before adding them here.

export async function loadIconRaw(name?: string) {
  if (!name) {
    return "";
  }

  try {
    // Innovadis custom override: return Bossard custom SVG when available
    if (IS_DEVELOPMENT) {
      try {
        const response = (await import(`../icons/bossard/${name}.svg?raw`)) as { default: string };
        return response.default;
      } catch (err) {
        // empty catch to hide icon errors
      }
    }

    // return default Virto SVG
    const fallbackResponse = (await import(`../icons/${name}.svg?raw`)) as { default: string };
    return fallbackResponse.default;
  } catch (error) {
    Logger.error(`Failed to load icon: ${name}`, error);
    return "";
  }
}
